
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CluPuSnackbarService } from '../../@services/clupu-snackbar.service';
import { ConnectorWRemDocsESignProcessService } from './connector-m-esign-process.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { BELOWMONITOR } from 'src/app/app.models';
import { MdESignProcessRunComponent } from './md-esign-process-run/md-esign-process-run.component';

@Component({
  selector: 'm-esign-process',
  templateUrl: './m-esign-process.component.html',
  styleUrls: ['./m-esign-process.component.scss'],
})
export class PublicWRemDocsMESignProcessComponent implements OnInit, OnDestroy {
    private LAYOUT_BELOWMONITOR : boolean;
    private layoutChangesSubscription = Subscription.EMPTY;
    esignToken : string | null = null;
    esignCodeArray : string[] = [];
    esignCode : string = '';
    showProgressBar : boolean = false;
    esignLinkItem : any;
    
    constructor(private connector : ConnectorWRemDocsESignProcessService, private route: ActivatedRoute, private _snackbarService : CluPuSnackbarService, private _matDialog : MatDialog, private breakpointObserver: BreakpointObserver){
       this.layoutChangesSubscription = this.breakpointObserver.observe([BELOWMONITOR]).subscribe((state) => { this.LAYOUT_BELOWMONITOR = state.breakpoints[BELOWMONITOR] });      
    }

    ngOnInit(): void {
      this.route.queryParamMap.subscribe(params => {
        this.esignToken = params.get('token');
      });
    }

    ngOnDestroy(): void {
      this.layoutChangesSubscription.unsubscribe();
    }

    doGetWCluDocumentESignLinkItemAction_PUPRemDocsESign(){
        if(this.esignToken == null || this.esignToken.length == 0) return;
        if(!this.esignCode || this.esignCode.length != 5) return;
        this.showProgressBar = true;
        this.connector.doGetWCluDocumentESignLinkItemAction_PUPRemDocsESign(this.esignToken, this.esignCode).subscribe({
            next : (res : any) => {
                this.esignLinkItem = res;
                console.log(this.esignLinkItem);
                this.showProgressBar = false;
            }, 
            error : (err : any) => {
                this.esignCode = '';
                this.esignCodeArray = [];
                this.hiddenInput.nativeElement.value = '';
                this.hiddenInput.nativeElement.focus();
                console.error(err);
                if(err.error != undefined && err.error.Message != undefined){ this._snackbarService.displayMessage("ERROR", err.error.Message); }
                else { this._snackbarService.displayMessage("ERROR", "Une erreur est survenue lors de l'enregistrement.."); }
                this.showProgressBar = false; 
            }
        })
    }

    doOpenMdESignProcessRunModalAction_PUPRemDocsESign(){
        let CC_WIDTH = this.LAYOUT_BELOWMONITOR ? '100%' : '600px';
        let CC_HEIGHT = this.LAYOUT_BELOWMONITOR ? '100%' : '80vh';
        this._matDialog.open(MdESignProcessRunComponent, {autoFocus: false, disableClose: true, width: '100%', maxWidth: CC_WIDTH, minHeight: CC_HEIGHT, maxHeight: CC_HEIGHT, height : '100%', data : { esignToken : this.esignToken, esignLinkItem : this.esignLinkItem } })
            .afterClosed()
            .subscribe((res) => {
              this.doGetWCluDocumentESignLinkItemAction_PUPRemDocsESign();
            });
    }

    @ViewChild('hiddenInput') hiddenInput!: ElementRef<HTMLInputElement>;
    focusHiddenInput() { setTimeout(() => this.hiddenInput?.nativeElement.focus(), 0); }
    refocusHiddenInput() { setTimeout(() => this.hiddenInput?.nativeElement.focus(), 100); }

    onInput(event: any) {
      if(this.showProgressBar) return;
      const value: string = event.target.value.replace(/\D/g, ''); // Supprime tout ce qui n’est pas chiffre
      this.esignCodeArray = value.split('').slice(0, 5);
      if (this.esignCodeArray.length === 5) {
        this.esignCode = this.esignCodeArray.join('');
        this.doGetWCluDocumentESignLinkItemAction_PUPRemDocsESign();
      }
    }
}
